import Vue from "vue";
import Component from "vue-class-component";
import useFiles from "@/hooks/useFiles";

@Component({
  setup() {
    const { updateFile, findFiles, deleteFile, uploadFilesToS3, uploadThenUpdate } = useFiles();
    return {
      filesFind: findFiles,
      filesUpdate: updateFile,
      filesDelete: deleteFile,
      filesUploadFileToS3: uploadFilesToS3,
      filesUpload: uploadThenUpdate,
    };
  },
})
export default class WithFiles extends Vue {
  public filesFind!: ReturnType<typeof useFiles>["findFiles"];
  public filesUpdate!: ReturnType<typeof useFiles>["updateFile"];
  public filesDelete!: ReturnType<typeof useFiles>["deleteFile"];
  public filesUploadFileToS3!: ReturnType<typeof useFiles>["uploadFilesToS3"];
  public filesUpload!: ReturnType<typeof useFiles>["uploadThenUpdate"];
}
